import ArrowRight2Icon from '../../../../../../assets/svgs/ArrowRight2'
import InfoLight from '../../../../../../assets/svgs/InfoLight'
import LiveIcon from '../../../../../../assets/svgs/Live'
import NotesIcon from '../../../../../../assets/svgs/Notes'
import PenIcon from '../../../../../../assets/svgs/Pen'
import People2Icon from '../../../../../../assets/svgs/People2'
import TableIcon from '../../../../../../assets/svgs/Table'
import TeslaLogo from '../../../../../../assets/svgs/TeslaLogo'
import useWindowWidth from '../../../../../../hooks/useWindowWidth'

import style from './style.module.css'

const CompanyCard = ({ company, handleCompanyOpen }) => {
  const isMobile = useWindowWidth() <= 768

  return (
    <div
      className={style.companyCard}
      onClick={() => handleCompanyOpen(company)}
    >
      <div className={style.companyCard_left}>
        <div className={style.companyCard_events}>
          <div className={style.companyCard_left_title}>
            <span>Events</span>
          </div>

          <div className={style.companyCard_events_list}>
            <a href="#" className={style.companyCard_events_list_item}>
              New product
            </a>
            <a href="#" className={style.companyCard_events_list_item}>
              Currently hiring
            </a>
            <a href="#" className={style.companyCard_events_list_item}>
              New launch
            </a>
          </div>
        </div>

        <div className={style.companyCard_people}>
          <div className={style.companyCard_left_title}>
            <span>People</span>
          </div>

          <div className={style.companyCard_people_desc}>
            <span>
              Hi, I'm Kristin Watson. I have been working as Human Resources at
              Tesla for 5 years.
            </span>
          </div>
        </div>
      </div>

      <div className={style.companyCard_middle}>
        <div className={style.companyCard_logoBlock}>
          <div className={style.companyCard_logo}>
            {company.logo ? (
              <>
                <TeslaLogo />
                <span className={style.companyCard_logo_subname}>
                  {company.name}
                </span>
              </>
            ) : (
              <span className={style.companyCard_logo_title}>
                {company.name}
              </span>
            )}
          </div>

          <div className={style.companyCard_rank}>
            <span className={style.companyCard_rank_num}>
              9.9/<span>10</span>
            </span>
            <InfoLight />
          </div>
        </div>

        {isMobile && (
          <div className={style.companyCard_employeeMessage}>
            <div>
              <span>
                Hi, I'm Kristin Watson. I have been working as Human Resources
                at Meta for 5 years.
              </span>
            </div>
          </div>
        )}

        <div className={style.companyCard_employees}>
          <div className={style.companyCard_employees_peopleImage}>
            <People2Icon />
          </div>
          <div className={style.companyCard_employees_tableImage}>
            <TableIcon />
          </div>
          <div className={style.companyCard_employeesBlock}>
            <div className={style.companyCard_employeesBlock_list}>
              <div className={style.companyCard_employeesBlock_item}></div>
              <div className={style.companyCard_employeesBlock_item}></div>
              <div className={style.companyCard_employeesBlock_item}></div>
              <div className={style.companyCard_employeesBlock_item}></div>
              <div className={style.companyCard_employeesBlock_count}>
                <span>4</span>
              </div>
            </div>
            <div className={style.companyCard_employeesBlock_text}>
              Tesla employees online. <span>Chat</span>
            </div>
          </div>
        </div>
      </div>

      <div className={style.companyCard_right}>
        <div className={style.companyCard_right_content}>
          <div className={style.companyCard_live}>
            <LiveIcon />
            <span>live launch</span>
          </div>

          <div className={style.companyCard_tryNow}>
            <div className={style.companyCard_tryNow_title}>
              <span>Try Now</span>
            </div>

            <div className={style.companyCard_tryNow_actions}>
              <div className={style.companyCard_tryNow_actions_item}>
                <PenIcon />

                <div className={style.companyCard_tryNow_actions_item_text}>
                  <span>Register for</span>
                  <span>
                    hackathon <ArrowRight2Icon />
                  </span>
                </div>
              </div>

              <div className={style.companyCard_tryNow_actions_item}>
                <NotesIcon />

                <div className={style.companyCard_tryNow_actions_item_text}>
                  <span>Participate in</span>
                  <span>
                    survey <ArrowRight2Icon />
                  </span>
                </div>
              </div>

              <div className={style.companyCard_tryNow_actions_item}>
                <PenIcon />

                <div className={style.companyCard_tryNow_actions_item_text}>
                  <span>Join the</span>
                  <span>
                    live Q&A <ArrowRight2Icon />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <a href="#" className={style.companyCard_right_seeMore}>
          See more details
        </a>
      </div>
    </div>
  )
}

export default CompanyCard
